module.exports = {
    digitalPayGiftCardFields: {
        cardNumber: 'giftCardNumber',
        pin: 'giftCardPin',
        amount: 'giftCardAmount',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/digitalpay-giftcard-fields.js